"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const dateDifference = (date1, date2 = new Date(Date.now()), options = {}) => {
    const { years: yearPrecision = true, months: monthPrecision = true, days: dayPrecision = true, hours: hourPrecision = false, minutes: minutePrecision = false, } = options;
    const [lesser, greater] = date2.getTime() < date1.getTime() ? [date2, date1] : [date1, date2];
    const years = yearPrecision ? (0, date_fns_1.differenceInYears)(greater, lesser) : 0;
    if (years > 0)
        return `${years}yr`;
    const months = monthPrecision ? (0, date_fns_1.differenceInMonths)(greater, lesser) : 0;
    if (months > 0)
        return `${months}mo`;
    const days = dayPrecision ? (0, date_fns_1.differenceInDays)(greater, lesser) : 0;
    if (days > 0)
        return `${days}d`;
    const hours = hourPrecision ? (0, date_fns_1.differenceInHours)(greater, lesser) : 0;
    if (hours > 0)
        return `${hours}h`;
    const minutes = minutePrecision ? (0, date_fns_1.differenceInMinutes)(greater, lesser) : 0;
    if (minutes > 0)
        return `${minutes}m`;
    return minutePrecision ? 'Now' : 'Today';
};
exports.default = dateDifference;
